module.exports = __webpack_public_path__ + "static/img/secondaryhuadongshifan.52a4fc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/secondaryhuadongshifan.jpg
// module id = XvSr
// module chunks = 46